import { useState } from 'react';
import { PermissionGuard } from '@/features/auth';
import { Pagination, ButtonLink } from '@/shared/components';
import { useItemsQuery } from '../hooks/useItemsQuery';
import { ItemDataTable } from '../components/ItemDataTable';

export function ItemList() {
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(20);

    const query = useItemsQuery({ page, per_page: perPage });
    const items = query.data?.data ?? [];
    const meta = query.data?.meta;

    return (
        <section className="space-y-4">
            <div className="flex items-center justify-between">
                <h1 className="text-2xl font-semibold">Items</h1>
                <PermissionGuard permission={{ resource: 'smr', action: 'item.add' }}>
                    <ButtonLink to="/smr-admin/items/new" size="sm">New Item</ButtonLink>
                </PermissionGuard>
            </div>

            <div className="space-y-4">
                <ItemDataTable data={items} isLoading={query.isLoading} />

                {meta && meta.last_page > 1 && (
                    <Pagination
                        currentPage={meta.current_page}
                        lastPage={meta.last_page}
                        total={meta.total}
                        perPage={meta.per_page}
                        from={meta.from}
                        to={meta.to}
                        onPageChange={setPage}
                        onPerPageChange={(n) => { setPerPage(n); setPage(1); }}
                    />
                )}
            </div>
        </section>
    );
}
